module.exports = __webpack_public_path__ + "static/media/reportCxcCompany.ba9aa7cd.svg";